import React from 'react';
import { ReactComponent as StarIcon } from 'icons/star.svg';

const RatingIcon = () => (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12.5" cy="12.5" r="12.5" fill="#F0A23B" />
    <path
      d="M13.0218 7.30575C12.9698 7.21302 12.8941 7.13581 12.8024 7.08207C12.7106 7.02833 12.6062 7 12.4999 7C12.3936 7 12.2892 7.02833 12.1975 7.08207C12.1058 7.13581 12.03 7.21302 11.978 7.30575C11.8558 7.52819 11.7383 7.75348 11.6254 7.98162C11.2699 8.7033 10.9676 9.45002 10.721 10.2158C10.636 10.4792 10.3842 10.6619 10.0958 10.6698C9.22142 10.6928 8.34989 10.7796 7.48817 10.9296C7.01516 11.0127 6.83733 11.5517 7.17344 11.8804C7.25003 11.9558 7.32744 12.0301 7.40566 12.1035C7.99054 12.6558 8.60894 13.1715 9.25735 13.6477C9.48162 13.8121 9.5739 14.0938 9.48835 14.3517C9.16243 15.3313 8.92919 16.3394 8.79168 17.3626C8.73056 17.824 9.22435 18.1497 9.65335 17.9297C10.504 17.4935 11.3175 16.9883 12.0856 16.419C12.2059 16.3312 12.351 16.2839 12.4999 16.2839C12.6489 16.2839 12.794 16.3312 12.9143 16.419C13.6822 16.9885 14.4957 17.4937 15.3465 17.9297C15.7749 18.1497 16.2693 17.824 16.2082 17.3626C16.1845 17.1894 16.1587 17.0173 16.1306 16.8462C15.9894 15.9999 15.7824 15.1658 15.5115 14.3517C15.4259 14.0938 15.5176 13.8121 15.7425 13.6477C16.4781 13.1087 17.1745 12.5181 17.8264 11.8804C18.1625 11.5517 17.9853 11.0127 17.5117 10.9296C16.6501 10.7788 15.7785 10.6919 14.9041 10.6698C14.7658 10.6676 14.6316 10.6229 14.5197 10.5416C14.4078 10.4604 14.3237 10.3466 14.2789 10.2158C13.9542 9.20789 13.5332 8.23298 13.0218 7.30575Z"
      fill="white"
    />
  </svg>
);

const RatingVehicleCard = ({ data }) => {
  return (
    <div className="rating-summary-card">
      <div className="rating-summary-card__header">
        <RatingIcon />
        <h3 className="rating-summary-card__title">Rating</h3>
      </div>

      <div className="rating-summary-card__list">
        {data?.rating_vehicle_with_driver?.total_reviews > 0 ? (
          <div className="rating-summary-card__item">
            <span className="rating-summary-card__label">Dengan Supir</span>
            <div className="rating-summary-card__score">
              <StarIcon color="#f1a33a" />
              <span className="rating-summary-card__value">{data?.rating_vehicle_with_driver?.rating ?? '-'}</span>
            </div>
          </div>
        ) : (
          <div className="rating-summary-card__item">
            <span className="rating-summary-card__label">Dengan Supir</span>
            <div className="rating-summary-card__score">
              <StarIcon color="#C3C3C3" />
              <span className="rating-summary-card__value">Belum ada rating</span>
            </div>
          </div>
        )}

        {data?.rating_vehicle_without_driver?.total_reviews > 0 ? (
          <div className="rating-summary-card__item">
            <span className="rating-summary-card__label">Tanpa Supir</span>
            <div className="rating-summary-card__score">
              <StarIcon color="#f1a33a" />
              <span className="rating-summary-card__value">{data?.rating_vehicle_without_driver?.rating ?? '-'}</span>
            </div>
          </div>
        ) : (
          <div className="rating-summary-card__item">
            <span className="rating-summary-card__label">Tanpa Supir</span>
            <div className="rating-summary-card__score">
              <StarIcon color="#C3C3C3" />
              <span className="rating-summary-card__value">Belum ada rating</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default RatingVehicleCard;
